/**
 * Application routes configuration
 * Centralizes all route definitions for better management
 */
const ROUTES = {
  HOME: '/',
  ABOUT_US: '/about-us',
  SWING_VISION: '/swing-vision',
  Q_ALPHA_FLOW: '/q-alpha-flow',
  OCTOPUS_SYNC: '/octopus-sync',
  SENTINEL: '/sentinel',
  HOW_TO_JOIN: '/how-to-join',
  CONTACTS: '/contacts',
  SITEMAP: '/sitemap',
  NOT_FOUND: '/not-found',
};

export default ROUTES;